getUserAccountBillingSubscriptionsWithDetailsZuora